import LegoPopup from 'lego-on-react/src/components/popup/popup.react';

import 'lego-on-react/src/components/popup/popup.css';

export const Popup = LegoPopup;
